var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesigns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.496,
    viewBox: "0 0 19.5 19.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1713",
    "data-name": "Group 1713",
    transform: "translate(-31.25 -212.25)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1684",
    "data-name": "Group 1684",
    transform: "translate(-808.899 -5002.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M858.9,5224.211a9,9,0,1,1-9-9A9,9,0,0,1,858.9,5224.211Z",
    transform: "translate(0 0)",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "D",
    transform: "translate(30.174 212.606)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(0.5)",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M13.02,11.227a2.761,2.761,0,0,1-1.149,1.121,3.743,3.743,0,0,1-1.786.4H7.826V6.394h2.259a3.814,3.814,0,0,1,1.786.391A2.723,2.723,0,0,1,13.02,7.892a3.4,3.4,0,0,1,.395,1.67A3.41,3.41,0,0,1,13.02,11.227Zm-1.455-.152a2,2,0,0,0,.563-1.513,2.009,2.009,0,0,0-.563-1.521A2.2,2.2,0,0,0,9.977,7.5H9.1v4.114h.882A2.2,2.2,0,0,0,11.565,11.075Z",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigns);
export default __webpack_public_path__ + "static/media/Designs.ff54cb9b6f737266acf70f352b955bea.svg";
export { ForwardRef as ReactComponent };